import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import User from "@/assets/js/models/user/User";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Domain extends JsonMapper {
  constructor(data = {}) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Domain.id_attribute_name]: null,
      [Domain.name_attribute_name]: null,
      [Domain.ssl_active_attribute_name]: false,
      [Domain.dns_active_attribute_name]: false,
      [Domain.user_id_attribute_name]: null,
      [Domain.user_attribute_name]: User,
      [Domain.user_default_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return Domain.id_attribute_name;
  }
  static getNameAttributeName() {
    return Domain.name_attribute_name;
  }
  static getSslActiveAttributeName() {
    return Domain.ssl_active_attribute_name;
  }
  static getDnsActiveAttributeName() {
    return Domain.dns_active_attribute_name;
  }
  static getUserIdAttributeName() {
    return Domain.user_id_attribute_name;
  }
  static getUserAttributeName() {
    return Domain.user_attribute_name;
  }
  static getUserDefaultAttributeName() {
    return Domain.user_default_attribute_name;
  }
  getId() {
    return this.getAttribute(Domain.getIdAttributeName());
  }
  getName() {
    return this.getAttribute(Domain.getNameAttributeName());
  }
  isUserDefault() {
    return this.getAttribute(Domain.getUserDefaultAttributeName());
  }
  hasSslActive() {
    return this.getAttribute(Domain.getSslActiveAttributeName());
  }
  hasDnsActive() {
    return this.getAttribute(Domain.getDnsActiveAttributeName());
  }
}
_defineProperty(Domain, "id_attribute_name", 'id');
_defineProperty(Domain, "name_attribute_name", 'name');
_defineProperty(Domain, "ssl_active_attribute_name", 'ssl_active');
_defineProperty(Domain, "dns_active_attribute_name", 'dns_active');
_defineProperty(Domain, "user_id_attribute_name", 'user_id');
_defineProperty(Domain, "user_attribute_name", 'user');
_defineProperty(Domain, "user_default_attribute_name", 'user_default');